export default __webpack_public_path__ + "images/SR.3c1e24d.png";